export const LocationSmallIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="23"
    fill="none"
    viewBox="0 0 18 23"
    {...props}>
    <path
      stroke="#455A64"
      strokeWidth="1.5"
      d="M16.714 9.697c0 2.73-2.857 6.804-5.126 9.608-1.183 1.463-1.775 2.195-2.73 2.195-.957 0-1.548-.732-2.732-2.195C3.857 16.501 1 12.427 1 9.697 1 5.17 4.518 1.5 8.857 1.5c4.34 0 7.857 3.67 7.857 8.197z"></path>
    <path
      stroke="#455A64"
      strokeWidth="1.5"
      d="M5.91 10.07c0 1.577 1.32 2.856 2.947 2.856s2.947-1.28 2.947-2.857c0-1.577-1.32-2.856-2.947-2.856s-2.946 1.279-2.946 2.856z"></path>
  </svg>
);
